import { List, Plus, Trash2 } from "lucide-react";
import { Outlet, useNavigate } from "react-router-dom";

import { Button } from "@/components/_atoms/button";
import { HeaderNavElement } from "@/components/_molecules/header-nav-element";
import { ListHeaderTitle } from "@/components/_molecules/list-header-title";
import { ListHeaderBar } from "@/components/_organisms/list-header-bar";
import { HeaderLayout } from "@/components/_templates/header-layout";
import { FeatureFlagToggle } from "@/domain/_shared/feature-flag/components/feature-flag-toggle";
import { useDomainTranslation } from "@/domain/_shared/i18n/use-domain-translation";
import { useCheckPermission } from "@/domain/_shared/permission/hooks/api/use-check-permission";
import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";

export const DataRequestListLayout = () => {
  const { currentWorkspace } = useCurrentWorkspaceContext();
  const { t } = useDomainTranslation("data-request");
  const { t: tTrash } = useDomainTranslation("trash");
  useDocumentTitle(t("list.title"));
  const navigate = useNavigate();
  const { hasPermission: hasManagePermission } = useCheckPermission({
    resource: "workspace",
    resourceId: currentWorkspace.id,
    action: "manage",
  });

  return (
    <div className="flex h-full max-h-full flex-col overflow-y-hidden">
      <HeaderLayout>
        <ListHeaderBar
          pageName={t("list.title")}
          title={<ListHeaderTitle icon={ClipboardDocumentListIcon} label={t("list.title")} />}
          actions={
            hasManagePermission ? (
              <Button size="xs" onClick={() => navigate("create")}>
                <Plus className="mr-2 h-3.5 w-3.5" />
                {t("list.createButton")}
              </Button>
            ) : null
          }
        >
          <HeaderNavElement to={`/${currentWorkspace.workspaceUrl}/data-requests`} icon={List} end>
            {tTrash("listTab")}
          </HeaderNavElement>
          <FeatureFlagToggle flag="enable-trash">
            <HeaderNavElement to={`/${currentWorkspace.workspaceUrl}/data-requests/trash`} icon={Trash2} end>
              {tTrash("trashTab")}
            </HeaderNavElement>
          </FeatureFlagToggle>
        </ListHeaderBar>
      </HeaderLayout>
      <Outlet />
    </div>
  );
};
